<template>
  <a @click="goMsEvent" class="navi__a" target="_blank">
    {{ label }}
    <font-awesome-icon
      :icon="['fas', 'chevron-right']"
      class="mx-2"
    ></font-awesome-icon>
  </a>
</template>
<style>
a.navi__a {
  cursor: pointer;
}
</style>
<script setup>
  import { defineProps, onMounted, ref } from 'vue'
  import config from '../../../const'

  const loading = ref(false)
  const site = ref('')

  const props = defineProps({
    label: {
      type: String,
      required: true,
    },
    loadMseventTokenObj: {
      type: Function,
      required: true,
    },
  })

  const goMsEvent = async (event) => {
    event.preventDefault()
    console.log('SSO_SITE_URL', config)
    let baseUrl
    switch (process.env.VUE_APP_ENV) {
      case 'production':
        baseUrl = config.SSO_SITE_URL
        break
      case 'staging':
      case 'mfj':
        baseUrl = 'https://staging.ms-event.net'
        break
      case 'sandbox':
        baseUrl = 'https://sandbox.ms-event.net'
        break
      case 'development':
        baseUrl = 'https://local7.ms-event.net:8443'
        break
      default:
        baseUrl = config.SSO_SITE_URL
    }
    if (!baseUrl) {
      throw new Error('コンフィグが未設定です。' + '.' + config.BASE_SERVICE_URL)
    }

    loading.value = true
    try {
      const token = await fetchTokenFromServer()

      const url = new URL(baseUrl)
      url.pathname += config.MSEVENT_COMPANY_KEY + '/user/'
      url.searchParams.set('a', 'login.user_token_login')
      url.searchParams.set('org_token', token)
      console.log('url', url.toString())
      // alert(url.toString())
      window.open(url.toString(), '_blank');
      // window.location.href = 
    } catch (e) {
      alert(e.message)
    } finally {
      loading.value = false
    }
  }

  async function fetchTokenFromServer() {
    const { status, data } = await props.loadMseventTokenObj()
    console.log('loadMseventTokenObj', status, data)
    if (status === 200) {
      const { body } = data
      return body.token
    }

    throw new Error('認証に失敗しました。トークンが無効です。')
  }

  onMounted(() => {
    site.value = config.SSO_SITE_URL
  })
</script>

<style scoped></style>
